import request from '@/utils/http';
// ---------管理端-------------
// 月底考核列表
export const monthList = (data) => {
    return request({
        url: `/api-srm-web/performance/portal/findMonthlyAssessmentList`,
        method: 'post',
        data
    });
};
// 月底考核明细列表
export const mangeDetails = (data) => {
    return request({
        url: `/api-srm-web/performance/portal/findCusPerformanceMonthlyAssessmentPage`,
        method: 'post',
        data
    });
};
// ------------工作台-------------
// 柱状图数据
export const getChart = (data) => {
    return request({
        url: `/api-srm-web/performance/portal/getCompositeAssessmentList`,
        method: 'post',
        data
    });
};
// 表格数据
export const getWorkTable = (data) => {
    return request({
        url: `/api-srm-web/performance/portal/findAssessmentDetailList `,
        method: 'post',
        data
    });
};
// 查询服务平台
export const findSiteInfo = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/findSiteInfo`,
        method: 'get',
        params: params
    });
};